import { RejetDocument } from "./models/rejete.stat";
import { ProjetDocument } from "./models/projet.stat";
import { ResumeDocument } from "./models/resume.stat";
import { RenouvellementDocument } from "./models/renouvellement.stat";

export const DocumentDemande = {
    RejetDocument, ProjetDocument, ResumeDocument, RenouvellementDocument
}